import React from 'react'
import * as Api from 'src/api'

interface SectionContextValue {
  readonly section: Api.AdministratorPortfolioSectionDetails | null
  readonly isLoading: boolean
  readonly mutate: () => void
}

const SectionContext = React.createContext<SectionContextValue | null>(null)

interface SectionProviderProps {
  readonly section: Api.AdministratorPortfolioSectionDetails | null
  readonly isLoading: boolean
  readonly mutate: () => void
  readonly children: React.ReactNode
}

export function SectionProvider({ section, isLoading, mutate, children }: SectionProviderProps): JSX.Element {
  const value = React.useMemo(() => ({ section, isLoading, mutate }), [section, isLoading, mutate])

  return <SectionContext.Provider value={value}>{children}</SectionContext.Provider>
}

export function useSection(): SectionContextValue {
  const context = React.useContext(SectionContext)
  if (context == null) {
    throw new Error('useSection must be used within a SectionProvider')
  }
  return context
}

export function useSectionData(): Api.AdministratorPortfolioSectionDetails | null {
  return useSection().section
}
